import * as React from "react";
import ReactMarkdown from "react-markdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IState } from "../../data/reducers/state";
import { IAssociationResource } from "../../types/association/Association";
import { IProfileTabProps } from "./ProfileTabType";

export interface IAssociationResourceTabProps extends IProfileTabProps {
  associationResources: IAssociationResource[];
  associationId: string;
  // actions: {
  //     getAppointmentsByPerson: (personId: string) => Promise<IAppointment<IAppointmentDetail>[]>
  // }
}

function AssociationResourceTab(props: IAssociationResourceTabProps) {
  function AssociationResourceField({ associationResource }) {
    return (
      <div>
        <h4 style={{ paddingBottom: "10px" }}>{associationResource.title}</h4>
        <ReactMarkdown>{associationResource.body}</ReactMarkdown>
        <hr />
      </div>
    );
  }

  return (
    <>
      {props.associationResources.map((ar, idx) => (
        <AssociationResourceField
          key={`ar-resource-${ar._id}`}
          associationResource={ar}
        />
      ))}
    </>
  );
}

function mapStateToProps(state: IState, props: IAssociationResourceTabProps) {
  return {
    associationResources:
      state.associations.resources[props.associationId] || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssociationResourceTab);
